import coreStore from './core-store'

const remoteResource = 'payment/api/v1/payments';

export default () => coreStore.queryStore(coreStore.createCoreStore('payment', remoteResource));